import h from "../../../../ui/design";
import {InputTextItem} from "../../../../model/items/inputText";
import m, {Vnode} from "mithril";
import {RadioItem} from "../../../../model/items/radio";
import {CellItem} from "../../../../model/items/cellItem";

export default class RadioCellInputTextItem {


	constructor(
		private radio: RadioItem,
		private inputText: InputTextItem,
		private readonly setValue: ((cellItem: CellItem, value: any)=>void)|null = null,
		private readonly onFinishInput: (()=>void)|null = null
	) { }

	public focus(): void {
			const $el = $(`input[name="${this.inputText.variableName}"]`).focus();
			setTimeout(() => {
			if (window.screen.width >= h.BC.md) {
				return;
			}
			$el[0]?.scrollIntoView?.();
		}, 500); // due phone software keyboard, should be solved via onResize event
	}


	public view(): Vnode|null {
		if (this.radio.isChecked()) {
			return m('input', {
				type: 'text',
                autocomplete: 'off',
				tabindex: 1,
				name: this.inputText.variableName,
				placeholder: this.radio.cell.grid.form.questionary.renderText(this.inputText.text),
				onkeydown: (e: KeyboardEvent) => {
					if (e.key === "Enter") {
						e.preventDefault();
						if (this.onFinishInput) {
							this.onFinishInput();
						}
					}
				},
				onkeyup: (e: KeyboardEvent) => {
					const value = (<HTMLInputElement>e.currentTarget).value;
					if (this.setValue) {
						this.setValue(this.inputText!, value);
					} else {
						this.radio.setVariable(value);
					}
				},
			});
		}
		return null;
	}
}